<template>
    <div class="filter-bar ui basic segment grid">
        <div class="ui form">
            <div class="row">
                <input type="text" v-model="filterText" @keyup.enter="doFilter" placeholder="Rechercher..."
                       class="marginRightResearch">
                <button title="researchDataOnCurrentRepo" class="btn btn-custom  marginRightResearch"
                        @click="doFilter">Rechercher
                </button>
                <button title="resetResearchOnCurrentRepo" class="btn btn-light" @click="resetFilter"
                        id="marginBtnReset">Annuler
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                filterText: ''
            }
        },
        methods: {
            doFilter() {
                this.$parent.$parent.research(this.filterText);
            },
            resetFilter() {
                this.filterText = '';
                this.$parent.$parent.displayTab();
            }
        }
    }
</script>

<style>
    .marginRightResearch {
        margin-right: 10px;
    }

    #marginBtnReset {
        margin-right: 15px;
    }
</style>


// WEBPACK FOOTER //
// resources/js/components/layout/FilterBar.vue